// extracted by mini-css-extract-plugin
module.exports = {"container":"_5f1881ebe0--container--Lmg27","text":"_5f1881ebe0--text--wJ6Hw"};